import endpoints from "../utils/endpoints";
import { message } from "antd";
import { Api } from "./api";
import { notificationError, notificationSucces } from "./notification";
import { removeEmpty } from "../utils/objectUtils";
import { exportCsv } from "../utils/fileUtils";
import { DateFormatEnum } from "../enums/dateFormatEnum";
import dayjs from "dayjs";

export async function getDevicesList(parameters: any){
    let res = {
      count: 0,
      page: null,
      perpage: 0,
      list: [],
    };
    const params = removeEmpty(parameters)
    await Api.get(endpoints.getDevicesList, {params}).then((response) => {
      if(response.status === 200 && response.data) {
        if(response.data.error) {
          notificationError(`${response.data.message}`)
        } else {
          res = response.data
        }
      }
    }).catch((err: string) => {
      notificationError('Could not get data from servers')
    })
    
    return res
}

export async function getListDevicesBulkEdit(parameters: any){
  let res = {
    count: 0,
    page: null,
    perpage: 0,
    list: [],
  };
  const params = removeEmpty(parameters)
  await Api.get(endpoints.getListDeviceBulkEdit, {params}).then((response) => {
    if(response.status === 200 && response.data) {
      if(response.data.error) {
        notificationError('Server Error', `${response.data.message}`)
      } else {
        res = response.data
      }
    }
  }).catch((err: string) => {
    notificationError('Error Retrieving Data', 'Could not get data from servers: ' + err)
  })
  console.log(res)
  return res
}

export async function pushDeviceBulkEdit(params: any){
  let res = {
    return: false
  };

  await Api.post(endpoints.pushDeviceBulkEdit, {params}).then((response) => {
    res = response.data
    if(!res || !res.return) {
      notificationError('Edit Failure', `${response.data.message}`)
    }
    if(res.return) {
      notificationSucces('Devices successfully updated')
    }
  }).catch((err: string) => {
    notificationError('Server Error',  err)
  })
}

export async function pushDeviceCommand(params: any){

  let res = {
    return: false
  };

  await Api.post(endpoints.pushDeviceCommand, {params}).then((response) => {
    res = response.data
    if(!res || !res.return) {
      notificationError('Unable to send command to devices')
    }
    if(res.return) {
      notificationSucces('Command sent successfully')
    }
  }).catch((err: string) => {
    notificationError('Could not get data from servers')
  })
}

export async function exportCsvDevices(params: any){
  let res = ''
  const name = 'devices_export_' + dayjs().format(DateFormatEnum.YEAR_MONTH_DAY)
  await Api.get(endpoints.exportCsvDevices, { params}).then((response) => {
    res = response.data
  }).catch((err: string) => {
    notificationError('Could not get data from servers')
  })
  exportCsv(res, name)
}

export async function getDeviceById (params: any) {
  let res = {
    id: "",
    locationId: "",
    identifier: "",
    alias: "",
    type: "pos",
    status: "Available",
    lastKnownVersion: "",
    lastKnownInternalIp: "",
    lastActivation: "",
    location: "",
    charity: "",
    distributor: "",
    model: "",
    os: "",
    gameType: "",
    allowSingleUse: false
  };

  await Api.get(endpoints.getDeviceById, {params}).then((response) => {
    res = response.data
    if(!res || res.id === '') {
      notificationError('Unable to get device informations')
    }
  }).catch((err: string) => {
    notificationError('Unable to get device informations')
  })
  return res
}

export async function createOrUpdateDevice (payload: any) {
  let valid = false;
  await Api.post(endpoints.createOrUpdateDevice, payload).then((response) => {
    if(response.status === 200) {
      if(response.data.error) {
        notificationError(`${response.data.message}`)
      } else {
        notificationSucces('Device was successfully updated')

        valid = true
      }
    } else {
      notificationError('Could not update device')
    }
  }).catch((err: string) => {
    notificationError('Could not update device')
  })

  return valid
}


